import { hueAngle, luminance, saturation } from '@limonade/color-science';
import { PerceptualHistogram } from './PerceptualHistogram.js';
function statistics(values, histogram) {
    const totalWeight = values.reduce((sum, sample) => sum + sample.weight, 0);
    const mean = totalWeight
        ? values.reduce((sum, sample) => sum + sample.value * sample.weight, 0) / totalWeight : 0;
    const variance = totalWeight
        ? values.reduce((sum, sample) => sum + (sample.value - mean) ** 2 * sample.weight, 0) / totalWeight : 0;
    return {
        histogram: histogram.normalized(),
        mean,
        standardDeviation: Math.sqrt(variance),
        sampleCount: values.length,
    };
}
export class HueDistributionAnalyzer {
    binCount;
    constructor(binCount = 24) {
        this.binCount = binCount;
    }
    analyze(samples) {
        const histogram = new PerceptualHistogram(this.binCount);
        const angles = [];
        let sin = 0;
        let cos = 0;
        for (const sample of samples) {
            const rgb = sample;
            const colorSaturation = saturation(rgb);
            if (colorSaturation < 0.03)
                continue;
            const angle = hueAngle(rgb);
            const weight = Math.max(0, sample.weight ?? 1) * colorSaturation;
            histogram.addCircularDegrees(angle, weight);
            const radians = angle * Math.PI / 180;
            sin += Math.sin(radians) * weight;
            cos += Math.cos(radians) * weight;
            angles.push({ angle, weight });
        }
        const circularMean = angles.length ? (Math.atan2(sin, cos) * 180 / Math.PI + 360) % 360 : 0;
        const totalWeight = angles.reduce((sum, item) => sum + item.weight, 0);
        const angularVariance = totalWeight
            ? angles.reduce((sum, item) => {
                const distance = Math.abs(((item.angle - circularMean + 540) % 360) - 180) / 180;
                return sum + distance ** 2 * item.weight;
            }, 0) / totalWeight : 0;
        return {
            histogram: histogram.normalized(),
            mean: circularMean,
            standardDeviation: Math.sqrt(angularVariance) * 180,
            sampleCount: angles.length,
        };
    }
}
export class SaturationDistributionAnalyzer {
    binCount;
    constructor(binCount = 20) {
        this.binCount = binCount;
    }
    analyze(samples) {
        const histogram = new PerceptualHistogram(this.binCount);
        const values = samples.map((sample) => {
            const value = saturation(sample);
            const weight = Math.max(0, sample.weight ?? 1);
            histogram.addNormalized(value, weight);
            return { value, weight };
        });
        return statistics(values, histogram);
    }
}
export class LuminanceDistributionAnalyzer {
    binCount;
    constructor(binCount = 32) {
        this.binCount = binCount;
    }
    analyze(samples) {
        const histogram = new PerceptualHistogram(this.binCount);
        const values = samples.map((sample) => {
            const value = luminance(sample);
            const weight = Math.max(0, sample.weight ?? 1);
            histogram.addNormalized(value, weight);
            return { value, weight };
        });
        return statistics(values, histogram);
    }
}
//# sourceMappingURL=distributions.js.map